// extracted by mini-css-extract-plugin
export default {"icon":"nTOsSIK4LUXx0_VeCZY3"};